// Importar Vue, Pinia y el componente principal de la aplicación
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import LayoutApp from './LayoutApp.vue';
import mitt from 'mitt';

// Importar el router para manejar las rutas de la aplicación
import router from './router';

// Importar Bootstrap (estilos y JavaScript)
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
// Estilos globales: inputs que se ajustan al contenido
import './assets/inputs-fit.css';

// i18n
import { createI18n } from 'vue-i18n';
import es from './locales/es.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import pt from './locales/pt.json';  
import ro from './locales/ro.json';
import { initPreferencesToSession } from './services/preferences';

// Importar el CSS global de z-index de SweetAlert2 para asegurar que siempre esté por encima de cualquier modal
import '../public/sweetalert2-force-zindex.css';

// Crear la aplicación Vue
const app = createApp(LayoutApp);

// Crear una instancia de mitt
const emitter = mitt();

// Agregar `emitter` como una propiedad global
app.config.globalProperties.$emitter = emitter;

// Crea una instancia de Pinia
const pinia = createPinia();

// Usa Pinia en la aplicación
app.use(pinia);

// Usa Vue Router si está configurado
app.use(router);

// Leer el idioma guardado en localStorage, si existe
const savedLocale = localStorage.getItem('selectedLocale') || 'es';

// Configuración de i18n
const i18n = createI18n({
  locale: savedLocale, // Idioma por defecto según localStorage
  fallbackLocale: 'en',
  // Desactivar la advertencia al usar HTML en mensajes traducidos.
  // Nota: esto silencia las advertencias pero no elimina el riesgo XSS.
  // Recomendado: refactorizar traducciones para evitar HTML en los mensajes
  // o sanitizar el HTML antes de insertarlo en el DOM.
  warnHtmlMessage: false,
  messages: { es, en, fr, it, pt, ro }
});

app.use(i18n);

// Inicializar preferencias nativas (copiar a sessionStorage) antes de montar
initPreferencesToSession().then(() => {
  app.mount('#app');
}).catch((e) => {
  console.warn('initPreferencesToSession failed, mounting anyway', e);
  app.mount('#app');
});
